var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    { staticClass: "settings-import" },
    [
      _c("preloader", { attrs: { display: _vm.loading } }),
      _vm._v(" "),
      _c("h2", { staticClass: "typographies-heading-h2" }, [
        _vm._v(_vm._s(_vm.$l10n.__("Nouvel import")))
      ]),
      _vm._v(" "),
      !_vm.isImportUnlimited
        ? _c("CompassAlert", {
            attrs: {
              "show-close": false,
              type: "warning",
              description: _vm.textAlertLimitedImport
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("p", { staticClass: "typographies-paragraph-medium-regular" }, [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$l10n.__(
                "Ajoutez vos données à Sellsy pour la première fois ou mettez les à jour selon vos besoins. Pour vous faciliter ce processus, vous garantir une fiabilité des données importées et vous faire gagner en productivité, vous bénéficiez de fonctionnalités comme la gestion des erreurs ou la gestion des doublons."
              )
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass:
            "documentation-link typographies-paragraph-medium-semibold"
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$l10n.__("Besoin d’aide ?")) +
              "\n        "
          ),
          _c("CompassLink", {
            attrs: {
              link: "https://help.sellsy.com/fr/?q=import",
              target: "blank",
              label: _vm.$t.__("common.actions.view_import_data_articles")
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "start-import-block" },
        [
          _c(
            "div",
            { staticClass: "information-block" },
            [
              _c("IconImport"),
              _vm._v(" "),
              _c("div", [
                _c("h3", { staticClass: "typographies-heading-h3" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$l10n.__(
                          "Importer ou mettre à jour vos données dans Sellsy"
                        )
                      ) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "typographies-paragraph-medium-regular" },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$l10n.__(
                            "Importez simplement vos données depuis une feuille de calcul pour retrouver rapidement vos sociétés, particuliers, contacts, commentaires, produits ou services !"
                          )
                        ) +
                        "\n                "
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("CompassButton", {
            attrs: {
              label: _vm.$t.__(
                "settings.import.SettingsImportComponent.start_import"
              )
            },
            on: {
              click: function($event) {
                _vm.showDialog = true
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("h4", { staticClass: "typographies-heading-h4" }, [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$l10n.__("Vos imports rapide, facile et sans risque !")
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "advantages-block-container" }, [
        _c("div", { staticClass: "advantages-block" }, [
          _c(
            "div",
            [_c("CompassIcon", { attrs: { icon: "flash", size: "large" } })],
            1
          ),
          _vm._v(" "),
          _c("div", [
            _c("h6", { staticClass: "typographies-heading-h6" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$l10n.__("Soyez prêts rapidement")) +
                  "\n                "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "typographies-paragraph-small-regular" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$l10n.__(
                      "Nous savons que votre temps est précieux, importez vos données facilement dans Sellsy pour débuter votre utilisation au plus vite."
                    )
                  ) +
                  "\n                "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "advantages-block" }, [
          _c(
            "div",
            [_c("CompassIcon", { attrs: { icon: "download", size: "large" } })],
            1
          ),
          _vm._v(" "),
          _c("div", [
            _c("h6", { staticClass: "typographies-heading-h6" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$l10n.__("Télécharger nos modèles")) +
                  "\n                "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "typographies-paragraph-small-regular" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$l10n.__(
                      "Nous mettons à votre disposition des modèles à télécharger pour vous aider et vous familiariser avec la structure des données dans Sellsy."
                    )
                  ) +
                  "\n                "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "advantages-block" }, [
          _c(
            "div",
            [_c("CompassIcon", { attrs: { icon: "revert", size: "large" } })],
            1
          ),
          _vm._v(" "),
          _c("div", [
            _c("h6", { staticClass: "typographies-heading-h6" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$l10n.__("Revenez en arrière sous 24h")) +
                  "\n                "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "typographies-paragraph-small-regular" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$l10n.__(
                      "Nous sauvegardons vos données régulièrement, revenez en arrière sous 24h pour effacer toutes les erreurs qu’un import aurait pu causer."
                    )
                  ) +
                  "\n                "
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "h2",
        {
          staticClass: "typographies-heading-h2",
          attrs: { id: "importAnchor" }
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$l10n.__("Historique des imports")) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _vm.getImportsList.length === 0
        ? _c("CompassAlert", {
            staticClass: "mb-0",
            attrs: {
              type: "neutral",
              description: _vm.$t.__("common.labels.no_import_maded"),
              "show-close": false
            }
          })
        : _c("ImportLogs"),
      _vm._v(" "),
      _vm.showDialog || _vm.getIsRestartImportNeeded
        ? _c("ImportPopup", {
            attrs: { "is-restarted": _vm.getIsRestartImportNeeded },
            on: { onClose: _vm.onCloseImportDialog }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }